/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/button-has-type */
/* eslint-disable eqeqeq */
/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable react/no-children-prop */
import React, { useEffect, useState } from 'react';
import { Container, CssBaseline } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useStyles from '../../../../assets/styles/pages/Request';
import Header from '../../../../components/Header';
import FooterMenuMain from '../../../../components/FooterMenuMain';

import { getStorege, saveStorege } from '../../../../helpers/db_storage';
import { coordinatesCurrent } from '../../../../helpers/utils/locationCoordinates';
import { useLoadingContext } from '../../../../providers/use-loading';

const Chat: React.FC = () => {
  const classeStyle = useStyles();
  const navigate = useNavigate();
  const { createloading } = useLoadingContext();

  const [dataOrder, setDataOrder] = useState<any>();

  const handleToPage = (url: string, replace = false) => {
    if (replace) {
      return navigate(url, { replace: true });
    }
    return navigate(url);
  };

  const handleToCha = async () => {
    createloading(true);

    const { lat, lng } = await coordinatesCurrent();
    if (lat && lng) {
      dataOrder.lat = lat;
      dataOrder.lng = lng;
      saveStorege('@chat/order', dataOrder);
    }
    createloading(false);

    handleToPage('/dashboard/user/request/chat/conversation');
  };

  const renderButtonChat = (idSituacao: number, idEntregadorChat: number) => {
    if (
      [5, 7].filter((situcao) => situcao == idSituacao).length == 1 &&
      idEntregadorChat != null
    ) {
      return (
        <div className={classeStyle.btnToChat} onClick={handleToCha}>
          Falar com o entregador
        </div>
      );
    }

    return (
      <div className={classeStyle.btnToChat} onClick={handleToCha}>
        Falar com o estabelecimento
      </div>
    );
  };

  useEffect(() => {
    const result = getStorege('@chat/order');

    setDataOrder(result);
  }, []);

  return (
    <>
      {dataOrder && (
        <Container maxWidth={false} className={classeStyle.container}>
          <Header children="Request" />

          <>
            <CssBaseline />
            <div className={classeStyle.gridChatContainer}>
              <h3 className={classeStyle.titleChat}>
                Está precisando de ajuda?
              </h3>
              <p className={classeStyle.segTitleChat}>
                Sistema de chat do Mais Delivery
              </p>
              <p className={classeStyle.descrChat}>
                Tire todas as suas dúvidas aqui, basta clicar no botão a baixo.
              </p>
              {renderButtonChat(
                dataOrder.idSituacao,
                dataOrder.idEntregadorChat,
              )}
            </div>
          </>

          <FooterMenuMain children="Request" />
        </Container>
      )}
    </>
  );
};

export default Chat;
